/* eslint-disable react/jsx-props-no-spreading */
import React, { memo, useLayoutEffect, useRef } from "react";
import usePrevious from "shared/hooks/usePrevious";
import breakpoints from "shared/utils/breakpoints";
import styled from "styled-components";

export interface SingleOTPInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  focus?: boolean;
}

export function SingleOTPInputComponent({
  focus,
  autoFocus,
  ...props
}: SingleOTPInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const prevFocus = usePrevious(!!focus);

  useLayoutEffect(() => {
    if (inputRef.current) {
      if (focus && autoFocus) {
        inputRef.current.focus();
      }
      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }
  }, [autoFocus, focus, prevFocus]);

  return <InputElement ref={inputRef} {...props} />;
}

const SingleOTPInput = memo(SingleOTPInputComponent);
export default SingleOTPInput;

export const InputElement = styled.input`
  @media ${breakpoints.device.max.xs} {
    width: ${100 / 7}% !important;
  }
`;
